'use client';

import { c as _c } from "react/compiler-runtime";
import './gallery-cinema.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import type { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { Image } from '../../../atoms/image/image.tsx';
import { Carousel, CarouselContent, CarouselItem, CarouselLazyLoadImage, CarouselNext, CarouselPrevious } from '../../../molecules/carousel/carousel.tsx';
import { FeatureCard } from '../../../molecules/feature-card/feature-card.tsx';
import { HeaderGroup } from '../../../molecules/header-group/header-group.tsx';
import { Lightbox, LightboxTrigger, LightboxVideoSchemas } from '../../../molecules/lightbox/lightbox.tsx';
import { getPlaceholderItems } from '../../../utils/placeholder-items.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
import { JumbotronNotable } from '../../jumbotron/notable/jumbotron-notable.tsx';
export const GalleryCinema: React.FC<FlexibleContentProps> = t0 => {
  const $ = _c(11);
  const {
    seoLevel: t1,
    media,
    items,
    alt,
    ...props
  } = t0;
  const seoLevel = t1 === undefined ? 2 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["skippy"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const hasHeaderContent = !!props.title || !!props.body;
  const hasHeaderCard = hasHeaderContent && media?.image;
  const hasHeaderGroup = hasHeaderContent && !media?.image;
  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
  const galleryItems = !items || items.length < 1 ? getPlaceholderItems(items, 1) : items;
  const hasBodyItems = galleryItems.some(_temp);
  const isPrimary = seoLevel === 1;
  const soloItem = galleryItems.length === 1 ? galleryItems[0] : undefined;
  const soloImage = soloItem && !hasBodyItems && !soloItem.media?.video ? soloItem.media : undefined;
  let t3;
  if ($[1] !== alt) {
    t3 = cn("GalleryCinema component", {
      "GalleryCinema--alt": alt
    });
    $[1] = alt;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = "GalleryCinema__container container flex flex-col gap-comfy-xl lg:gap-roomy-xs";
  const t5 = hasHeaderCard && <FeatureCard {...props} {...getBaseSizeProps(headerDisplayLevel)} seoLevel={seoLevel} media={media} imagePlacement="right" variant="horizontal" inline={true} />;
  const t6 = hasHeaderGroup && <HeaderGroup {...props} seoLevel={seoLevel} />;
  const t7 = soloImage && <figure className="GalleryCinema__solo m-none"><div className="GalleryCinema__image"><Image image={soloImage.image} aspectRatio="16-9" rounded="lg" hasPlaceholder={true} priority={isPrimary} sizeIntent="full" /></div>{soloImage.caption && <figcaption className="GalleryCinema__attribution label label-lg mt-comfy-sm">{soloImage.caption}</figcaption>}</figure>;
  const t8 = !soloImage && <Carousel aria-label={t("skippy:gallery.title", {
    title: props.title
  })} opts={{
    align: "start",
    loop: false,
    watchFocus: false
  }}><LightboxVideoSchemas items={galleryItems} /><div className="GalleryCinema__wrapper flex flex-col gap-comfy-lg"><div className={cn("GalleryCinema__carousel", {
        "has-body": hasBodyItems
      })} data-length={galleryItems.length}><CarouselContent>{galleryItems.map((slide, index) => <CarouselItem key={["slide", index, slide.title].join("-")} index={index} className="GalleryCinema__slide" aria-label={`${t("skippy:gallery.slide.title", {
            index: index + 1,
            length: galleryItems.length
          })}${slide.title && ` - ${slide.title}`}`}><figure className="m-none"><Lightbox key={["lightbox", index, slide.title].join("-")} items={galleryItems} startIndex={index}><LightboxTrigger className="Lightbox__trigger  w-full" ariaLabel={t("skippy:gallery.open")}><>{!hasBodyItems && <div className="GalleryCinema__image"><CarouselLazyLoadImage index={index} media={slide.media} isVideoThumbnail={!!slide.media?.video} priority={isPrimary && index === 0} /></div>}{hasBodyItems && <JumbotronNotable seoLevel={hasHeaderContent ? seoLevel + 1 : seoLevel} {...{
                      ...slide,
                      alt,
                      inline: true
                    }} />}</></LightboxTrigger></Lightbox>{slide.media?.caption && <figcaption className="GalleryCinema__attribution label label-lg mt-comfy-sm">{slide.media.caption || slide.title}</figcaption>}</figure></CarouselItem>)}</CarouselContent></div>{galleryItems.length > 1 && <div className="GalleryCinema__arrows flex gap-comfy-sm items-center justify-end"><CarouselPrevious /><CarouselNext /></div>}</div></Carousel>;
  let t9;
  if ($[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== t8) {
    t9 = <div className={t4}>{t5}{t6}{t7}{t8}</div>;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t3 || $[9] !== t9) {
    t10 = <section className={t3}>{t9}</section>;
    $[8] = t3;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
};
function _temp(item) {
  return !!item.body;
}